import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountState } from './account.entity';
import { selectAll, selectIds } from './account.reducers';
import { AppState } from './../../../store/reducers/index';

export const accountFeatureSelector = createFeatureSelector<AccountState>('accountState');

export const getAllAccounts = createSelector(
    accountFeatureSelector,
    selectAll
);

export const areAccountsLoaded = createSelector(
    accountFeatureSelector,
    state => state.loaded
);

export const currentSelectedAccountDetail = createSelector(
    accountFeatureSelector,
    state => state.currentAccount
);



